import React, { useEffect, useState } from 'react'
import styles from './reportCard.module.css'
import { Arrow, Code, InterviewVideo, PromptHire, UserImg } from '../../../assets/svgComponent'
import { Editor } from "@monaco-editor/react";
import ScreenRecorder from '../ScreenRecorder';
import apiCall from '../../../API/apiService';
import apiEndpoints from '../../../API/apiEndpoints';
import { toasty } from '../../../../Helper';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

const ReportCard = () => {
    const navigate = useNavigate()
    const candidateColorCode = {
        'STRONG_NO_HIRE': { borderColor: '#FCA5A5', backgroundColor: '#FEE2E2', textColor: '#DC2626' },
        'STRONG_HIRE': { borderColor: '#86EFAD', backgroundColor: '#DCFCE8', textColor: '#15803C' },
        'HIRE': { borderColor: '#93B4FD', backgroundColor: '#DBE6FE', textColor: '#1D58D8' },
        'LEANING_HIRE': { borderColor: '#B9B9C0', backgroundColor: '#EEEEF0', textColor: '#4E4E56' },
        'LEANING_NO_HIRE': { borderColor: '#FCA5A5', backgroundColor: '#FEE2E2', textColor: '#DC2626' },
    }

    const [reportData, setReportData] = useState(null)
    const isMobile = useMediaQuery({
        query: "(max-width: 620px)",
    });
    const isPad = useMediaQuery({
        query: "(max-width: 1020px)",
    });
    const [expandedAnswers, setExpandedAnswers] = useState({});
    const [interviewId, setInterviewId] = useState();


    useEffect(() => {
        const url = window.location.href;
        const pathSegments = url.split("/");
        const id = pathSegments[4];
        setInterviewId(id)
        console.log("id:", id);
        if (id) {
            fetchData(id);
        }
    }, []);

    const fetchData = async (id) => {
        try {
            const result = await fetch(`${process.env.REACT_APP_BASE_URL}/${apiEndpoints.GET_REPORT_CARD}/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiNjczM2I5Y2UzZmE3NjFhYzIyNTc0ZjQ3IiwidXNlcl9uYW1lIjoiSGFyc2giLCJvcmdfaWRzIjpbIjY3MmI5MjQzYWMwOTU4NmFmYTI2NGRjNCJdLCJleHAiOjE3NTA0OTAyNDd9.b8kcNZSveb2XmCHtgh11E8nrBb2QU36CDQWWJ4XVscM`
                }
            });
            const response = await result.json()

            if (result?.status) {
                setReportData(response);
            } else {
                toasty(`Unexpected response structure:${response?.detail}`, "error")
            }
        } catch (error) {
            console.error("Error fetching organization data:", error);
            toasty(`Error fetching report card data: ${error.message}`, "error");
        } finally {
            console.log("reached finally block")
        }
    };

    const toggleAnswerExpansion = (questionIndex, skillIndex) => {
        const key = `${skillIndex}-${questionIndex}`;
        setExpandedAnswers(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const Box = ({ color, fillPercentage, isAfterScore }) => {
        return (
            <div
                style={{
                    width: isMobile ? '22px' : '34px',
                    height: isMobile ? '12px' : '17px',
                    margin: '4px',
                    backgroundColor: isAfterScore ? '#E2E2E5' : color,
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                }}
            >
                {/* Only show white overlay for partial fill */}
                {fillPercentage < 100 && fillPercentage > 0 && (
                    <div
                        style={{
                            height: '100%',
                            width: `${100 - fillPercentage}%`,
                            backgroundColor: '#E2E2E5',
                            position: 'absolute',
                            top: '0',
                            right: '0',
                        }}
                    ></div>
                )}
            </div>
        );
    };

    // Main component to render the row of boxes
    const BoxRow = ({ score }) => {
        // Color distribution (how many boxes for each color)
        const colorDistribution = [
            { color: '#EF4444', count: 2 },
            { color: '#FB7D3C', count: 2 },
            { color: '#FB9724', count: 2 },
            { color: '#22C55E', count: 4 },
        ];

        // Calculate which boxes should be filled and by how much
        const boxes = colorDistribution.flatMap(({ color, count }) =>
            Array(count).fill().map((_, index, array) => {
                // Calculate the absolute box number across all colors
                const absoluteBoxNumber = colorDistribution
                    .slice(0, colorDistribution.findIndex(d => d.color === color))
                    .reduce((sum, d) => sum + d.count, 0) + index + 1;

                let fillPercentage = 100;
                const isAfterScore = absoluteBoxNumber > Math.ceil(score);

                if (absoluteBoxNumber === Math.ceil(score)) {
                    // The partial box should be filled based on the decimal part
                    fillPercentage = (score % 1) * 100;
                }

                return (
                    <Box
                        key={`${color}-${index}`}
                        color={color}
                        fillPercentage={fillPercentage}
                        isAfterScore={isAfterScore}
                    />
                );
            })
        );

        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {boxes}
            </div>
        );
    };

    if (!reportData) return null


    return (
        <div style={{ background: '#F7F7F8', height: '100vh', overflow: 'scroll' }}>
            <div style={{
                border: '1px solid #DADADD',
                width: isMobile ? '100%' : isPad ? window.innerWidth / 1.2 : window.innerWidth / 2.4,
                height: 'auto',
                margin: 'auto',
                overflow: 'scroll',
                paddingTop: 26,
                paddingBottom: 32,
                background: '#fff',
                overflowX: 'hidden'
            }}>
                <img src={PromptHire} style={{ width: '100%', height: 40, marginBottom: 32 }} />
                {/* Candidate Details */}
                <div className={styles.cardContainer}>
                    <div className={styles.header}>
                        <div style={{ display: 'flex', gap: 12 }}>
                            <img src={UserImg} />
                            <span>{reportData.applicant_details.name}</span>
                            <div className={styles.languageContainer}>
                                {/* <img src={Code} /> */}
                                <span className={styles.languageName}>{reportData.role_name}</span>
                            </div>
                            <div className={styles.candidateCategory} style={{ borderColor: candidateColorCode[reportData.hire_recommendation].borderColor, background: candidateColorCode[reportData.hire_recommendation].backgroundColor }}>
                                <span className={styles.candidateCategoryName} style={{ color: candidateColorCode[reportData.hire_recommendation].textColor }}>
                                    {reportData.hire_recommendation.replace('_', ' ')}
                                </span>
                            </div>
                        </div>
                        {reportData?.applicant_details.resume_url && <div style={{ display: 'flex', alignItems: 'center' }}>
                            <a
                                href={"https://docs.google.com/viewerng/viewer?url="+reportData?.applicant_details.resume_url}
                                target="_blank"
                                className={styles.linkToCV}
                            >
                                link to cv
                            </a>
                            <img src={Arrow} />
                        </div>}
                    </div>

                    <div className={styles.candidateDetails}>
                        <div className={styles.candidateSection}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '46%' }}>
                                <span className={styles.nameLable}>NAME</span>
                                <span className={styles.nameValue}>{reportData.applicant_details.name}</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '46%' }}>
                                <span className={styles.nameLable}>CONTACT NUMBER:</span>
                                <span className={styles.nameValue}>{reportData.applicant_details.contact_number}</span>
                            </div>
                        </div>

                        <div className={styles.candidateSection}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '46%' }}>
                                <span className={styles.nameLable}>EDUCATION:</span>
                                <span className={styles.nameValue}>
                                    {reportData.applicant_details.education.map(edu =>
                                        `${edu.college ?? 'N/A'} ${edu.degree && `/ ${edu.degree}`}`
                                    ).join(', ')}
                                </span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '46%' }}>
                                <span className={styles.nameLable}>SKILLS:</span>
                                <span className={styles.nameValue}>
                                    {reportData.applicant_details.skills.join(', ')}
                                </span>
                            </div>
                        </div>

                        <div className={styles.candidateSection}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '46%' }}>
                                <span className={styles.nameLable}>YEARS of EXPERIENCE</span>
                                <span className={styles.nameValue}>{reportData.applicant_details.years_of_exp}</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '46%' }}>
                                <span className={styles.nameLable}>NOTABLE COMPANIES:</span>
                                <span className={styles.nameValue}>
                                    {reportData.applicant_details.notable_companies.join(', ')}
                                </span>
                            </div>
                        </div>

                        <div className={styles.candidateSection}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '46%' }}>
                                <span className={styles.nameLable}>CV Score:</span>
                                <span className={styles.nameValue}>{reportData.applicant_details.score}</span>
                            </div>
                        </div>

                        <div className={styles.candidateSection}>
                            {reportData.applicant_details.current_compensation && <div style={{ display: 'flex', flexDirection: 'column', width: '46%' }}>
                                <span className={styles.nameLable}>CURRENT COMPENSATION:</span>
                                <span className={styles.nameValue}>
                                    {(reportData.applicant_details.current_compensation / 100000).toFixed(2)} Lac
                                </span>
                            </div>}
                            {reportData.applicant_details.expected_compensation && <div style={{ display: 'flex', flexDirection: 'column', width: '46%' }}>
                                <span className={styles.nameLable}>EXPECTED COMPENSATION</span>
                                <span className={styles.nameValue}>
                                    {(reportData.applicant_details.expected_compensation / 100000).toFixed(2)} Lac
                                </span>
                            </div>}
                        </div>
                    </div>

                    <div className={styles.summeryWrapper}>
                        {reportData.applicant_details.summary && <>
                            <span className={styles.summeryLable}>CV Summary:</span>
                            <span className={styles.summeryValue}>{reportData.applicant_details.summary}</span>
                        </>}

                        <img
                            src={InterviewVideo}
                            style={{ cursor: 'pointer' }}
                            onClick={() => window.open(reportData.applicant_details.recording_url, '_blank')}
                        />
                    </div>
                </div>

                {/* Final Remarks */}
                <div className={styles.finalRemarksContainer}>
                    <span className={styles.finalRemarksText}>FINAL REMARKS</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                        <path d="M6.95364 10.3311V6.75496C6.95364 4.98013 7.35099 3.48344 8.1457 2.2649C8.96689 1.01987 10.2517 0.2649 12 0V2.06622C10.9669 2.17218 10.2517 2.54305 9.8543 3.17881C9.48344 3.78808 9.29801 4.70199 9.29801 5.92053L7.70861 5.68212H11.9603V10.3311H6.95364ZM0 10.3311V6.75496C0 4.98013 0.397351 3.48344 1.19205 2.2649C2.01324 1.01987 3.29801 0.2649 5.04636 0V2.06622C4.01325 2.17218 3.29801 2.54305 2.90066 3.17881C2.5298 3.78808 2.34437 4.70199 2.34437 5.92053L0.754967 5.68212H5.00662V10.3311H0Z" fill="#BFD3FE" />
                    </svg>
                    <span className={styles.finalRemarksBody}>{reportData.overall_feedback.final_remarks}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                        <path d="M6.95364 10.6622V8.59596C7.98676 8.49 8.68874 8.13238 9.0596 7.52311C9.45695 6.88735 9.65563 5.96019 9.65563 4.74165L11.245 4.98006H6.99338V0.331055H12V3.90721C12 5.68205 11.5894 7.17874 10.7682 8.39728C9.97351 9.61582 8.70199 10.3708 6.95364 10.6622ZM0 10.6622V8.59596C1.03311 8.49 1.7351 8.13238 2.10596 7.52311C2.50331 6.88735 2.70199 5.96019 2.70199 4.74165L4.29139 4.98006H0.0397352V0.331055H5.04636V3.90721C5.04636 5.68205 4.63576 7.17874 3.81457 8.39728C3.01987 9.61582 1.74834 10.3708 0 10.6622Z" fill="#BFD3FE" />
                    </svg>
                </div>

                {/* Pros and Cons */}
                <div className={styles.candidateFeedback}>
                    <div className={styles.candidateWellWrapper}>
                        <div className={styles.candidateFeedbackTitle}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M16.2117 7.7822C16.4687 9.30978 16.2336 10.8795 15.5403 12.2647C14.847 13.65 13.7313 14.779 12.3545 15.4889C10.9777 16.1987 9.41091 16.4527 7.88036 16.214C6.34981 15.9754 4.9347 15.2565 3.83936 14.1611C2.74402 13.0658 2.02512 11.6507 1.78647 10.1201C1.54781 8.58958 1.80175 7.02278 2.51161 5.64596C3.22147 4.26914 4.35052 3.15353 5.73575 2.46022C7.12098 1.76692 8.69071 1.53178 10.2183 1.78876C10.3643 1.81458 10.4942 1.89701 10.5798 2.01812C10.6653 2.13924 10.6996 2.28923 10.6751 2.43548C10.6507 2.58173 10.5694 2.7124 10.4491 2.79907C10.3288 2.88574 10.1791 2.9214 10.0327 2.89829C9.14541 2.74903 8.2363 2.79491 7.36858 3.03273C6.50086 3.27055 5.69539 3.6946 5.00822 4.27536C4.32105 4.85612 3.76868 5.57965 3.38957 6.39559C3.01045 7.21154 2.81369 8.10029 2.81298 9.00001C2.81164 10.5147 3.36834 11.9768 4.37673 13.107C4.78568 12.5138 5.30516 12.0051 5.90673 11.6086C5.95808 11.5746 6.0192 11.5583 6.08068 11.5624C6.14216 11.5664 6.20061 11.5906 6.24704 11.6311C7.01117 12.2923 7.98787 12.6562 8.99837 12.6562C10.0089 12.6562 10.9856 12.2923 11.7497 11.6311C11.7961 11.5906 11.8546 11.5664 11.9161 11.5624C11.9775 11.5583 12.0387 11.5746 12.09 11.6086C12.6922 12.0051 13.2123 12.5138 13.6221 13.107C14.6313 11.9771 15.1887 10.515 15.188 9.00001C15.188 8.65416 15.1593 8.30892 15.1022 7.96782C15.0893 7.89465 15.0909 7.81964 15.1072 7.74712C15.1234 7.6746 15.1538 7.60602 15.1967 7.54533C15.2395 7.48463 15.294 7.43304 15.3569 7.39352C15.4199 7.354 15.49 7.32734 15.5633 7.31508C15.6366 7.30281 15.7116 7.3052 15.7839 7.32208C15.8563 7.33897 15.9246 7.37002 15.9849 7.41346C16.0452 7.45689 16.0963 7.51184 16.1352 7.57513C16.1741 7.63842 16.2001 7.7088 16.2117 7.7822ZM5.90673 8.43751C5.90673 9.04939 6.08817 9.64754 6.42812 10.1563C6.76806 10.6651 7.25124 11.0616 7.81655 11.2958C8.38186 11.5299 9.00391 11.5912 9.60404 11.4718C10.2042 11.3524 10.7554 11.0578 11.1881 10.6251C11.6208 10.1925 11.9154 9.6412 12.0348 9.04107C12.1542 8.44094 12.0929 7.81889 11.8587 7.25358C11.6246 6.68827 11.228 6.20509 10.7193 5.86515C10.2105 5.5252 9.61236 5.34376 9.00048 5.34376C8.17996 5.34376 7.39306 5.66971 6.81286 6.2499C6.23267 6.83009 5.90673 7.61699 5.90673 8.43751ZM16.7109 2.41454C16.6587 2.36224 16.5967 2.32075 16.5284 2.29244C16.4601 2.26414 16.3869 2.24957 16.313 2.24957C16.2391 2.24957 16.1659 2.26414 16.0976 2.29244C16.0293 2.32075 15.9672 2.36224 15.915 2.41454L14.063 4.26727L13.3359 3.53954C13.2837 3.48728 13.2216 3.44582 13.1534 3.41754C13.0851 3.38925 13.0119 3.3747 12.938 3.3747C12.8641 3.3747 12.7909 3.38925 12.7226 3.41754C12.6543 3.44582 12.5923 3.48728 12.54 3.53954C12.4877 3.5918 12.4463 3.65385 12.418 3.72213C12.3897 3.79041 12.3752 3.8636 12.3752 3.93751C12.3752 4.01142 12.3897 4.0846 12.418 4.15289C12.4463 4.22117 12.4877 4.28321 12.54 4.33548L13.665 5.46048C13.7172 5.51278 13.7793 5.55427 13.8476 5.58257C13.9159 5.61088 13.9891 5.62545 14.063 5.62545C14.1369 5.62545 14.2101 5.61088 14.2784 5.58257C14.3467 5.55427 14.4087 5.51278 14.4609 5.46048L16.7109 3.21048C16.7632 3.15824 16.8047 3.0962 16.833 3.02791C16.8613 2.95963 16.8759 2.88643 16.8759 2.81251C16.8759 2.73859 16.8613 2.66539 16.833 2.5971C16.8047 2.52882 16.7632 2.46678 16.7109 2.41454Z" fill="#16A34A" />
                            </svg>
                            <span className={styles.candidateWellLable}>What went well:</span>
                        </div>
                        <div style={{ width: isMobile ? window.innerWidth / 1.1: isPad ? window.innerWidth / 1.3  :  window.innerWidth / 2.5, maxHeight: '200px', overflowY: 'auto' }}>
                            {reportData.overall_feedback.positive_points.map((point, index) => (
                                <p key={index} className={styles.candidateFeedbackDesc} style={{ 
                                    wordBreak: 'break-word',
                                    whiteSpace: 'pre-wrap'
                                }}>− {point}</p>
                            ))}
                        </div>
                    </div>

                    <div className={styles.candidateWellWrapper}>
                        <div className={styles.candidateFeedbackTitle}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M14.625 2.25H3.375C3.07663 2.25 2.79048 2.36853 2.5795 2.5795C2.36853 2.79048 2.25 3.07663 2.25 3.375V14.625C2.25 14.9234 2.36853 15.2095 2.5795 15.4205C2.79048 15.6315 3.07663 15.75 3.375 15.75H14.625C14.9234 15.75 15.2095 15.6315 15.4205 15.4205C15.6315 15.2095 15.75 14.9234 15.75 14.625V3.375C15.75 3.07663 15.6315 2.79048 15.4205 2.5795C15.2095 2.36853 14.9234 2.25 14.625 2.25ZM13.5 12.9375H4.5C4.35082 12.9375 4.20774 12.8782 4.10225 12.7727C3.99676 12.6673 3.9375 12.5242 3.9375 12.375C3.9375 12.2258 3.99676 12.0827 4.10225 11.9773C4.20774 11.8718 4.35082 11.8125 4.5 11.8125H13.5C13.6492 11.8125 13.7923 11.8718 13.8977 11.9773C14.0032 12.0827 14.0625 12.2258 14.0625 12.375C14.0625 12.5242 14.0032 12.6673 13.8977 12.7727C13.7923 12.8782 13.6492 12.9375 13.5 12.9375ZM13.5 9.5625H4.5C4.35082 9.5625 4.20774 9.50324 4.10225 9.39775C3.99676 9.29226 3.9375 9.14918 3.9375 9C3.9375 8.85082 3.99676 8.70774 4.10225 8.60225C4.20774 8.49676 4.35082 8.4375 4.5 8.4375H13.5C13.6492 8.4375 13.7923 8.49676 13.8977 8.60225C14.0032 8.70774 14.0625 8.85082 14.0625 9C14.0625 9.14918 14.0032 9.29226 13.8977 9.39775C13.7923 9.50324 13.6492 9.5625 13.5 9.5625ZM13.5 6.1875H4.5C4.35082 6.1875 4.20774 6.12824 4.10225 6.02275C3.99676 5.91726 3.9375 5.77418 3.9375 5.625C3.9375 5.47582 3.99676 5.33274 4.10225 5.22725C4.20774 5.12176 4.35082 5.0625 4.5 5.0625H13.5C13.6492 5.0625 13.7923 5.12176 13.8977 5.22725C14.0032 5.33274 14.0625 5.47582 14.0625 5.625C14.0625 5.77418 14.0032 5.91726 13.8977 6.02275C13.7923 6.12824 13.6492 6.1875 13.5 6.1875Z" fill="#EA580C" />
                            </svg>
                            <span className={styles.candidateWellLable}>What can be improved:</span>
                        </div>
                        <div style={{ width: isMobile ? window.innerWidth / 1.1: isPad ? window.innerWidth / 1.3  :  window.innerWidth / 2.5, maxHeight: '200px', overflowY: 'auto' }}>
                            {reportData.overall_feedback.negative_points.map((point, index) => (
                                <p key={index} className={styles.candidateFeedbackDesc} style={{ 
                                    wordBreak: 'break-word',
                                    whiteSpace: 'pre-wrap',
                                    display:'flex'
                                }}>− {point}</p>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Interview Score */}
                <div className={styles.interviewScoreContainer}>
                    <span className={styles.interviewScoreTitle}>Interview scores</span>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        gap: '12px',
                        width: '100%' 
                    }}>
                        <BoxRow score={reportData.overall_feedback.interviewee_score} />
                        <span className={styles.interviewScoreValue} style={{
                            color: reportData.overall_feedback.interviewee_score <= 2 ? '#EF4444' 
                                : reportData.overall_feedback.interviewee_score > 2 && reportData.overall_feedback.interviewee_score <= 4 ? '#FB7D3C'
                                : reportData.overall_feedback.interviewee_score > 4 && reportData.overall_feedback.interviewee_score <= 6 ? '#FB9724'
                                : '#22C55E',
                            marginLeft: 'auto'
                        }}>
                            {reportData.overall_feedback.interviewee_score}
                            <span style={{ color: "#93939D" }}> / 10</span>
                        </span>
                    </div>
                </div>

                <p className={styles.scoreFeedback}>Skill-level Scores & Feedback</p>
                <div className={styles.interviewScoreContainer} style={{ marginTop: 24 }}>
                    {reportData.skills_feedback.map((skillData, index) => (
                        <React.Fragment key={index}>
                            <div style={{ display: 'flex', gap: 4 }}>
                                <span className={styles.skillLable}>{skillData.skill}</span>
                                <span className={styles.skillValue}>
                                    <span style={{ fontWeight: '300', fontSize: 14 }}>
                                        {skillData.score} <span style={{ color: "#93939D" }}> / 10</span>
                                    </span>
                                </span>
                            </div>
                            {skillData.questions.map((question, qIndex) => (
                                <div key={qIndex}>
                                    <span className={styles.interviewScoreValue} style={{ color: '#27272A', fontWeight: '500' }}>
                                        Q{qIndex + 1}: {question.question}
                                    </span>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span className={styles.score}>Score:</span>
                                            <span className={styles.scoreValue}>
                                                {question.score}<span style={{ color: '#5F5F6A' }}>/10</span>
                                            </span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span className={styles.score}>Feedback:</span>
                                            <span className={styles.scoreValue}>{question.feedback}</span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span className={styles.score}>SUMMARY:</span>
                                            <span className={styles.scoreValue}>{question.summary}</span>
                                        </div>
                                        
                                        {question.hints && 
                                         Object.entries(question.hints).some(([_, value]) => value > 0) && (
                                            <div style={{ 
                                                marginTop: '10px', 
                                                marginBottom: '10px',
                                                padding: '10px', 
                                                backgroundColor: '#F9FAFB', 
                                                border: '1px solid #E5E7EB',
                                                borderRadius: '8px'
                                            }}>
                                                <span style={{ 
                                                    fontWeight: '500', 
                                                    color: '#4B5563', 
                                                    display: 'block', 
                                                    marginBottom: '5px',
                                                    fontFamily: 'Inter'
                                                }}>
                                                    Hints Used:
                                                </span>
                                                <div style={{ 
                                                    display: 'flex', 
                                                    flexDirection: 'column', 
                                                    gap: '5px' 
                                                }}>
                                                    {Object.entries(question.hints)
                                                        .filter(([_, value]) => value > 0)
                                                        .map(([key, value], hintIndex) => (
                                                            <div key={hintIndex} style={{ fontSize: '14px', color: '#6B7280', fontFamily: 'Inter' }}>
                                                                <span style={{ fontWeight: '500' }}>{key}:</span> {value}
                                                            </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {question.question_type === 'CODING' ? (
                                        <div style={{ position: 'relative', width: '100%' }}>
                                            <span style={{ background: '#27272A', display: 'flex', borderRadius: '12px 12px 0px 0px', color: '#fff', fontWeight: '500', padding: '8px 12px' }}>
                                                {question.language || 'Code'}
                                            </span>
                                            <Editor
                                                options={{
                                                    minimap: { enabled: false },
                                                    contextmenu: false,
                                                    readOnly: true,
                                                    quickSuggestions: false,
                                                    copyWithSyntaxHighlighting: false,
                                                    selectionClipboard: false,
                                                    find: {
                                                        addExtraSpaceOnTop: false,
                                                        autoFindInSelection: 'never',
                                                        seedSearchStringFromSelection: false
                                                    }
                                                }}
                                                height="26vh"
                                                theme="vs-dark"
                                                language={question.language?.toLowerCase() || 'javascript'}
                                                value={question.answer}
                                            />
                                        </div>
                                    ) : (
                                        <div className={styles.answerContainer} style={{ 
                                            height: expandedAnswers[`${index}-${qIndex}`] ? 'auto' : '200px',
                                            position: 'relative',
                                            borderRadius: '8px',
                                            border: '1px solid #E5E7EB',
                                            overflow: 'hidden'
                                        }}>
                                            {question.question_type === 'CODE_REACT' ? <div style={{display:'flex', width:'100%', justifyContent:'space-between'}}>
                                                <span className={styles.score}>Answer:</span>
                                                <span 
                                                    onClick={() => window.open(`/code-preview/${interviewId}`, '_blank')} 
                                                    className={[styles.livePreview]}
                                                >Live Preview</span>
                                            </div>:<span className={styles.score}>Answer:</span>}
                                            
                                            <div style={{ 
                                                backgroundColor: '#F3F4F6',
                                                padding: '12px',
                                                
                                                whiteSpace: 'pre-wrap',
                                                fontFamily: 'Inter',
                                                fontSize: '14px',
                                                overflowY: expandedAnswers[`${index}-${qIndex}`] ? 'visible' : 'auto'
                                            }}>
                                                {question.answer.split('\n').map((line, lineIndex) => {
                                                    if (line.startsWith('Interviewer:')) {
                                                        const [label, ...rest] = line.split(':');
                                                        return <div key={lineIndex} style={{ color: '#4E4E56', marginBottom: '8px' }}>
                                                            <span style={{ color: '#1D4ED8' }}>Interviewer:</span>
                                                            {rest.join(':')}
                                                        </div>;
                                                    } else if (line.startsWith('Candidate:')) {
                                                        const [label, ...rest] = line.split(':');
                                                        return <div key={lineIndex} style={{ color: '#4E4E56', marginBottom: '8px' }}>
                                                            <span style={{ color: '#C2410C' }}>Candidate:</span>
                                                            {rest.join(':')}
                                                        </div>;
                                                    }
                                                    return <div key={lineIndex} style={{ color: '#4E4E56', marginBottom: '8px' }}>{line}</div>;
                                                })}
                                            </div>
                                            <div 
                                                onClick={() => toggleAnswerExpansion(qIndex, index)}
                                                style={{
                                                    cursor: 'pointer',
                                                    textAlign: 'center',
                                                    padding: '5px',
                                                    color: '#4B5563',
                                                    borderTop: '1px solid #E5E7EB',
                                                    backgroundColor: '#F3F4F6',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    position: 'sticky',
                                                    bottom: 0,
                                                    width: '5%',
                                                    marginBottom: '-12px',
                                                    marginLeft: '300px',
                                                    borderRadius: '0 0 8px 8px'
                                                }}
                                            >
                                                <svg 
                                                    width="10" 
                                                    height="10" 
                                                    viewBox="0 0 12 12" 
                                                    fill="none" 
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    style={{
                                                        transform: expandedAnswers[`${index}-${qIndex}`] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                        transition: 'transform 0.2s ease-in-out',
                                                        display: 'block'
                                                    }}
                                                >
                                                    <path 
                                                        d="M2.5 4.5L6 8L9.5 4.5" 
                                                        stroke="#4B5563" 
                                                        strokeWidth="2" 
                                                        strokeLinecap="round" 
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ReportCard